import { __ } from "@wordpress/i18n";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useMenu } from '../../contexts/MenuContext';
import WithForm from '../../layouts/WithForm/WithForm';
import Switch from '../../components/Switch/Switch';
import withForm from "../../layouts/WithForm/WithForm";

const Extra = ({handleChange}) => {
	const {
		settingData
	} = useMenu();

	return (
		<>
			<div className="content-section">
				<div className="leftSection">
					<h2 className="title header-1 primary-text-color semi-bold">
						{__("Uninstall option", "access-control")}
					</h2>
					
				</div>

				<div className="rightSection">
					<div className="setting-item">
						<div className="input-container">
							<OverlayTrigger
								placement="top"
								overlay={
									<Tooltip id="uninstall-plugin-tooltip">
										{__(
											"Delete all the plugin data",
											"access-control",
										)}
									</Tooltip>
								}
							>
								<img
									src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
									alt="icon"
									className="icon"
									style={{ cursor: "pointer" }}
								/>
							</OverlayTrigger>

							<div className="input-field">
								<span className="setting-label header-1 primary-text-color semi-bold">
									{__("Delete all the plugin data upon uninstalling.", "access-control")}
								</span>
								<Switch 
									name="more.extra.enable_delete_plugin_data_on_uninstall"
									checked={settingData?.more?.extra?.enable_delete_plugin_data_on_uninstall} 
									onChange={handleChange} 
								/>
							</div>
						</div>
							<div style={{marginLeft: "30px"}}>
								{__("All role modifications and custom roles created using this plugin are stored in the database. If you wish to remove this data when uninstalling the plugin, please check the checkbox below. Before proceeding with the uninstallation, ensure that no users are assigned to these custom roles, as deleting this data while roles are still in use may result in technical issues.","access-control")}
							</div>
						
					</div>
				</div>
			</div>	
		</>
	);
};

export default withForm( Extra, 'more.extra' );